import { render } from "./ProductSpec.vue?vue&type=template&id=0d065cb8"
import script from "./ProductSpec.vue?vue&type=script&lang=js"
export * from "./ProductSpec.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__